import { KEY_ROWS, type KeyState } from "../game/keyboard";

interface KeyboardProps {
  states: Map<string, KeyState>;
  onKey: (key: string) => void;
  disabled: boolean;
}

const STATE_CLASS: Record<KeyState, string> = {
  g: "bg-tile-correct text-white",
  y: "bg-tile-present text-white",
  b: "bg-tile-absent text-white/80",
};

export function Keyboard({ states, onKey, disabled }: KeyboardProps) {
  return (
    <div className="mx-auto flex w-full max-w-[520px] select-none flex-col gap-[7px] px-[6px]">
      {KEY_ROWS.map((row, i) => (
        <div key={i} className={`flex justify-center gap-[6px] ${i === 1 ? "px-[5%]" : ""}`}>
          {row.map((k) => {
            const wide = k === "back";
            const st = states.get(k);
            const colour = st ? STATE_CLASS[st] : "bg-key-base text-key-text";
            return (
              <button
                key={k}
                type="button"
                disabled={disabled}
                onPointerDown={(e) => {
                  e.preventDefault();
                  onKey(k);
                }}
                onContextMenu={(e) => e.preventDefault()}
                className={`key flex h-[56px] items-center justify-center rounded-[7px] font-bold uppercase transition-transform duration-75 active:scale-95 active:brightness-90 disabled:opacity-60 ${wide ? "flex-[1.6]" : "flex-1 text-[18px]"} ${colour}`}
                aria-label={k}
              >
                {k === "back" ? (
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" />
                    <line x1="18" y1="9" x2="12" y2="15" />
                    <line x1="12" y1="9" x2="18" y2="15" />
                  </svg>
                ) : (
                  k
                )}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
